import { useMemo } from 'react';
import { ui } from '@procuros/datachecks';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { DisplayModes, WebEDIRowData } from '../../Types';
import { createColumns } from './helpers';

export type HookProps = {
  config: Array<ui.Field>;
  selectableRows?: boolean;
  deletableRows?: boolean;
  deleteQuantityField?: string;
  withIndexColumn?: boolean;
  nestedLevelField?: string;
  displayMode?: DisplayModes;
};

export const useGenerateWebEDIColumns = ({
  config,
  selectableRows,
  deletableRows,
  withIndexColumn,
  deleteQuantityField,
  nestedLevelField,
  displayMode,
}: HookProps): Array<ColumnDef<WebEDIRowData, unknown>> => {
  const columnHelper = useMemo(() => createColumnHelper<WebEDIRowData>(), []);

  const enableEmbeddedRowActions = displayMode === DisplayModes.create || displayMode === DisplayModes.edit;

  return useMemo(
    () =>
      createColumns(
        config,
        columnHelper,
        Boolean(selectableRows),
        Boolean(deletableRows),
        enableEmbeddedRowActions,
        deleteQuantityField,
        nestedLevelField,
        withIndexColumn,
      ),
    [
      config,
      columnHelper,
      selectableRows,
      deletableRows,
      enableEmbeddedRowActions,
      deleteQuantityField,
      nestedLevelField,
      withIndexColumn,
    ],
  );
};
